import type { FC, ReactNode } from 'react'
import type { ConsortiumSlug, SimulationSelection } from '@/types'

import { SectionHeading } from '@/components/landing/section-heading'
import { ConsortiumSimulator } from '@/components/landing/consortium-simulator'

interface SimulatorSectionProps {
    initialSlug?: ConsortiumSlug
    title?: ReactNode
    description?: ReactNode
    onRequestProposal: (selection: SimulationSelection) => void
}

export const SimulatorSection: FC<SimulatorSectionProps> = ({
    initialSlug,
    title = 'Veja quanto fica a sua parcela',
    description = 'Escolha o tipo de consórcio, o valor do crédito e o prazo. O cálculo aparece na hora, junto com a comparação com um financiamento.',
    onRequestProposal
}): ReactNode => {
    return (
        <section
            id='simulador'
            aria-labelledby='simulador-titulo'
            className='relative overflow-hidden bg-ink py-24 text-primary-foreground sm:py-32'
        >
            <div
                aria-hidden='true'
                className='pointer-events-none absolute inset-0 bg-dot-grid-light [mask-image:radial-gradient(ellipse_at_top,black_15%,transparent_70%)]'
            />

            <div
                aria-hidden='true'
                className='pointer-events-none absolute -right-48 -top-48 size-[36rem] rounded-full bg-gold/10 blur-3xl'
            />

            <div className='relative mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='simulador-titulo'
                    tone='light'
                    eyebrow='Simulador de parcelas'
                    title={title}
                    description={description}
                />

                <div className='mt-14 lg:mt-16'>
                    <ConsortiumSimulator initialSlug={initialSlug} onRequestProposal={onRequestProposal} />
                </div>
            </div>
        </section>
    )
}
